// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","spiner":"Loading_spiner__3bGPC"};